import { Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { l } from "@shared/locales/i18n";

import * as styles from "./OrSection.styles";

const OrSection = () => {
  const { t } = useTranslation();

  return (
    <Typography
      variant="footnote"
      isMarginless
      customCss={styles.orSection}
      intention="neutral"
      colorIntensity="subtle"
    >
      {t(l.magicLink.Or)}
    </Typography>
  );
};

export { OrSection };
